/**
 * HealthHub — Auditoria R2
 *
 * Hub único de saúde: consolida 7 páginas (Sistema, Modelos, Provedores,
 * Memória, Factual, Alucinação, Geral) em 1 rota com tabs. Reduz pressão
 * cognitiva e elimina duplicação na sidebar.
 */
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import Health from "@/pages/Health";
import MemoryHealth from "@/pages/MemoryHealth";
import ModelsHealth from "@/pages/ModelsHealth";
import FactualHealth from "@/pages/FactualHealth";
import HallucinationHealth from "@/pages/HallucinationHealth";
import ProvidersHealth from "@/pages/admin/ProvidersHealth";
import SystemHealth from "@/pages/admin/SystemHealth";
import SubsystemSlos from "@/pages/admin/SubsystemSlos";
import PeopleMemoryHealth from "@/pages/admin/PeopleMemoryHealth";
import CortexSentinel from "@/pages/admin/CortexSentinel";
import HealthDashboard from "./HealthDashboard";

const TABS = [
  { id: "slos", label: "SLOs por subsistema", Component: SubsystemSlos },
  { id: "sistema", label: "Sistema", Component: SystemHealth },
  { id: "geral", label: "Geral", Component: Health },
  { id: "modelos", label: "Modelos", Component: ModelsHealth },
  { id: "provedores", label: "Provedores", Component: ProvidersHealth },
  { id: "memoria", label: "Memória", Component: MemoryHealth },
  { id: "people-memory", label: "People Memory", Component: PeopleMemoryHealth },
  { id: "cortex-sentinel", label: "Cortex Sentinel", Component: CortexSentinel },
  { id: "factual", label: "Factual", Component: FactualHealth },
  { id: "alucinacao", label: "Alucinação", Component: HallucinationHealth },
] as const;

export default function HealthHub() {
  const [params, setParams] = useSearchParams();
  const active = params.get("tab") ?? "slos";

  return (
    <div className="container mx-auto py-6 space-y-4">
      <div>
        <h1 className="text-2xl font-bold">Saúde da plataforma</h1>
        <p className="text-sm text-muted-foreground">
          SLOs por subsistema (WM, LTM, Skill, Multimodal, Factual, People Memory) + diagnóstico de sistema, modelos, provedores, memória, factual e alucinação.
        </p>
      </div>

      <Tabs
        value={active}
        onValueChange={(v) => {
          const next = new URLSearchParams(params);
          next.set("tab", v);
          setParams(next, { replace: true });
        }}
      >
        <TabsList className="flex-wrap h-auto">
          {TABS.map((t) => (
            <TabsTrigger key={t.id} value={t.id}>
              {t.label}
            </TabsTrigger>
          ))}
          <TabsTrigger value="sentinel-smoke">Sentinel Smoke</TabsTrigger>
        </TabsList>
        {TABS.map(({ id, Component }) => (
          <TabsContent key={id} value={id} className="mt-4">
            <Component />
          </TabsContent>
        ))}
        <TabsContent value="sentinel-smoke" className="mt-4">
          <HealthDashboard />
        </TabsContent>
      </Tabs>
    </div>
  );
}
